export const availableModules = (dataset, schoolYear, date = new Date()) => {
  const time = date.getTime();
  return new Set(
    dataset.calendar
      .filter(
        (row) =>
          row.an_scolar === schoolYear &&
          new Date(row.data_start).getTime() <= time &&
          time <= new Date(row.data_end).getTime(),
      )
      .map((row) => row.id_module),
  );
};

export const temporalScores = (dataset, profile, date = new Date()) => {
  const available = availableModules(dataset, profile.schoolYear, date);
  const scores = new Map();

  dataset.activities.forEach((activity) => {
    const isAvailable = available.has(activity.id_module);
    scores.set(activity.id, {
      activityId: activity.id,
      score: isAvailable ? 1 : 0.3,
      available: isAvailable,
      moduleId: activity.id_module,
    });
  });

  return scores;
};
